// extracted by mini-css-extract-plugin
export default {"before":"before___gY_oa_common"};
    if(module.hot) {
      // 1790873740890
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  